import ReactMarkdown from "react-markdown";
import { Link, useParams } from "react-router-dom";
import posts from "../content/posts.json";

export const Post = () => {
  const { id } = useParams();
  const post = posts.find((p) => p.id === id);

  if (!post) {
    return (
      <p className="empty-note">
        Hmm, that post doesn't exist. <Link to="/blog">Back to the blog</Link>
      </p>
    );
  }

  return (
    <article className="post">
      <header className="page-header">
        <time className="post-date">{post.date}</time>
        <h1>{post.title}</h1>
        {post.subtitle && <p className="tagline">{post.subtitle}</p>}
        <div className="tag-row">
          {post.tags.map((tag) => (
            <span key={tag} className="tag">{tag}</span>
          ))}
        </div>
      </header>
      <div className="prose">
        <ReactMarkdown>{post.content}</ReactMarkdown>
      </div>
      <p className="see-all">
        <Link to="/blog">&larr; Back to the blog</Link>
      </p>
    </article>
  );
};
